import React from 'react';
import { Section } from '../ui/Section';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
export function WhatIsIt() {
  const points = ['Detectar dónde se te va la energía todos los días', 'Dejar de exigirte sin sentir culpa', 'Recuperar energía mental y emocional', 'Vivir con energía suficiente para trabajar, estudiar y vivir'];
  return <Section background="light-purple" data-id="element-290">
      <div className="max-w-6xl mx-auto" data-id="element-291">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-292">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-293">
            <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6" data-id="element-294">
              ¿Qué es{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-fuchsia-600 to-pink-600" data-id="element-295">
                ENERGÍA REAL?
              </span>
            </h2>

            <p className="text-xl text-slate-700 mb-8 leading-relaxed" data-id="element-296">
              ENERGÍA REAL es un método digital, práctico y guiado, que podés
              hacer a tu ritmo, incluso estando cansada.
            </p>

            <p className="text-lg font-bold text-slate-900 mb-4" data-id="element-297">Te ayuda a:</p>

            <div className="space-y-4 mb-8" data-id="element-298">
              {points.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-299">
                  <div className="bg-fuchsia-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-300">
                    <Check className="w-4 h-4 text-fuchsia-600" strokeWidth={3} data-id="element-301" />
                  </div>
                  <span className="text-lg text-slate-800" data-id="element-302">{point}</span>
                </div>)}
            </div>

            <div className="bg-white p-4 rounded-xl border-l-4 border-fuchsia-500 shadow-sm" data-id="element-303">
              <p className="text-lg font-bold text-slate-900" data-id="element-304">
                No es motivación vacía. Es alivio con dirección.
              </p>
            </div>
          </motion.div>

          <motion.div className="relative flex justify-center" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6
        }} data-id="element-305">
            <div className="absolute inset-0 bg-gradient-to-tr from-fuchsia-200/40 to-pink-200/40 rounded-3xl transform rotate-3 blur-2xl" data-id="element-306"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7uboQsFcy5xinmt7NYeF57/Portada.png" alt="Energía Real - Portada del método" className="relative rounded-2xl shadow-2xl w-full max-w-md object-cover border-4 border-white" data-id="element-307" />
          </motion.div>
        </div>
      </div>
    </Section>;
}